import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { AuthLayout } from "@/pages/Login";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ name: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { applySession } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { api.get(`/auth/invite/${token}`).then((r) => setInfo(r.data.data)).catch((e) => setError(errMsg(e))); }, [token]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { const { data } = await api.post("/auth/accept-invite", { token, ...form }); await applySession(data.data); toast.success("Welcome aboard"); navigate("/"); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout title="Join organization" subtitle={info ? `You were invited to ${info.org_name} as ${info.role}.` : "Checking invite…"}>
      {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="invite-error">{error}</p>}
      {info && !info.expired && info.status === "pending" && (
        <form onSubmit={submit} className="space-y-4" data-testid="accept-invite-form">
          <Field label="Email"><Input value={info.email} disabled data-testid="invite-email" /></Field>
          {!info.user_exists && <>
            <Field label="Your name"><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="invite-name-input" /></Field>
            <Field label="Create password"><Input type="password" required minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="invite-password-input" /></Field>
          </>}
          <Button type="submit" className="w-full" disabled={busy} data-testid="accept-invite-submit">{busy ? "Joining…" : "Accept invite"}</Button>
        </form>
      )}
      {info && (info.expired || info.status !== "pending") && <p className="text-sm text-slate-600" data-testid="invite-unavailable">This invite is no longer valid. Ask your admin for a new one.</p>}
    </AuthLayout>
  );
}
